
  // Export
  module.exports =
  {
    view: {
        _init: function() {
            $('#nine-hundred-mb-modal').modal('show');

            $('#nine-hundred-mb-modal').on('hide.bs.modal', function (e) {
                window.location.href = '/';
            })
        }
    }
  }